import { Link, useParams } from "react-router-dom"
import ReviewPageTemplate from "@/components/templates/ReviewPageTemplate"
import SeoHead from "@/components/seo/SeoHead"
import { getReviewBySlug } from "@/data/reviews"

function ReviewDetail() {
  const { slug } = useParams()
  const product = getReviewBySlug(slug)

  if (!product) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-teal-50">
        <SeoHead
          title="Review Not Found | Vitamin Vital Portal"
          description="This Vitamin Vital Portal review page could not be found. Browse expert supplement reviews and comparison guides."
          path={`/reviews/${slug || ""}`}
          type="website"
        />
        <div className="max-w-3xl mx-auto px-4 py-24 text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Review not found</h1>
          <p className="text-gray-600 mb-8">
            That review is not in the Vitamin Vital Portal library yet. Browse current product reviews instead.
          </p>
          <Link
            to="/reviews"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-full font-semibold"
          >
            Back to Top Reviews
          </Link>
        </div>
      </div>
    )
  }

  return <ReviewPageTemplate product={product} />
}

export default ReviewDetail
